<template>
    <div class="pr-4">
        <button class="text-right inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 -mt-20" @click.prevent="authoringNewNote = !authoringNewNote">+ New Note</button>
        <div v-show="authoringNewNote">
            <div class="form-field">
                <textarea class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md" rows="3" ref="newNoteContent" v-model="newNoteContent"></textarea>
                <button class="mt-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click.prevent="saveNote">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NoteCreate',
        props: {
            account: {
                required: false,
                default: null,
            }
        },
        data() {
            return {
                authoringNewNote: false,
                newNoteContent: null,
            }
        },
        methods: {
            saveNote() {
                let accountId = this.account ?? this.$route.params.accountId
                if (this.newNoteContent !== null && this.newNoteContent.length > 0) {
                    axios.post(route('accounts.notes.create', accountId), {
                        content: this.newNoteContent,
                    })
                        .then(response => {
                            this.$emit('created', response.data.data)
                            this.newNoteContent = null
                            this.authoringNewNote = false
                        })
                }
            },
        },
        watch: {
            authoringNewNote(newValue) {
                if (newValue) {
                    setTimeout(() => this.$refs['newNoteContent'].focus(), 100)
                }
            }
        }
    }
</script>
